import React from "react";

const TileLoading = () => (
  <div className="tile-loading">
    <div className="bar bar1" />
    <div className="space actg1" />
    <div className="bar bar2" />
    <div className="space actg1" />
    <div className="bar bar3" />
    <div className="space actg1" />
    <div className="bar bar4" />
    <div className="space actg1" />
    <div className="bar bar5" />
  </div>
);

export default TileLoading;
